import { RequirementsList as ReactRequirementsList } from "@certn/cascadia-react/components/requirements-list/RequirementsList";
import { memo } from "react";

import { CascadiaRequirementsListProps } from "./types";

export const RequirementsList = memo(function (
  props: CascadiaRequirementsListProps
) {
  return (
    <ReactRequirementsList
      requirementsList={props.requirements}
      testID={props.testID}
    />
  );
});
